import { render, staticRenderFns } from "./DataErasure.vue?vue&type=template&id=78370c22&scoped=true&"
import script from "./DataErasure.vue?vue&type=script&lang=js&"
export * from "./DataErasure.vue?vue&type=script&lang=js&"
import style0 from "./DataErasure.vue?vue&type=style&index=0&id=78370c22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78370c22",
  null
  
)

export default component.exports